/**
 * Недавно открытые люди, рассылки и воронки: пустой поиск (⌘K) показывает их первыми. Список
 * свой у каждого браузера, в localStorage, и без хранилища просто пуст.
 */
export interface RecentItem {
	kind: "person" | "broadcast" | "funnel"
	id: string
	label: string
	hint?: string
	to: string
}

const STORAGE_KEY = "backoffice:recent"
const LIMIT = 8

export function readRecentItems(): RecentItem[] {
	try {
		const value: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]")
		return Array.isArray(value) ? (value as RecentItem[]) : []
	} catch {
		return []
	}
}

export function rememberRecentItem(item: RecentItem) {
	try {
		const rest = readRecentItems().filter((other) => other.to !== item.to)
		localStorage.setItem(STORAGE_KEY, JSON.stringify([item, ...rest].slice(0, LIMIT)))
	} catch {
		// Без хранилища «Недавние» просто не появятся.
	}
}
